import Vue from 'vue';
import VueRouter from 'vue-router';
import translate from './modules/translate';
import appManage from './modules/appManage';
import baseRouter from './baseRouter';
import ticketInfo from './modules/detail';

import testData from './modules/testData';

import appName from './modules/appName';

import assetManage from './modules/assetManage';

import poManage from './modules/poManage';

import facilityManage from './modules/facilityManage';

import boardManage from './modules/boardManage';

import platformManage from './modules/platformManage';

import workOrderManage from './modules/workOrderManage';

Vue.use(VueRouter);
const routes = [
  ...translate,
  ...appManage,
  ...baseRouter,
  ...ticketInfo,
  ...testData,
  ...appName,
  ...assetManage,
  ...poManage,
  ...facilityManage,
  ...boardManage,
  ...platformManage,
  ...workOrderManage,
];

const appManage1 = [...appManage];

const router = new VueRouter({
  mode: 'history',
  routes,
  translate,
  appManage,
  ticketInfo,
  testData,
  baseRouter,
  assetManage,
  poManage,
  facilityManage,
  boardManage,
  platformManage,
  workOrderManage,
});

console.log('全部的路由路径小的路径', router);

export const ROUTES = [
  { name: 'appManage', title: '业务管理' },
  //{ name: 'assetManage', title: '资产管理' },
  { name: 'boardManage', title: '数据看板' },
  { name: 'platformManage', title: '平台建设' },
  { name: 'facilityManage', title: '设施运维' },
].map(({ name, title, isFlat }) => {
  // 查找父路由
  const parentRoute = router.options?.routes?.find((r) => r.name === name) || { children: [] };

  // 递归处理子路由路径
  function processChildren(children, parentPath) {
    return (children || []).map((child) => {
      const fullPath = `${parentPath}/${child.path}`.replace(/\/+/g, '/'); // 拼接路径，避免双斜杠
      return {
        ...child,
        path: fullPath,
        children: processChildren(child.children, fullPath), // 递归拼接子路径
      };
    });
  }

  return {
    name,
    title,
    path: `/${name}`,
    isFlat,
    children: processChildren(parentRoute?.children || [], `/${name}/formal`), // 这里确保路径正确
  };
});

console.log('全部的路由路径', ROUTES);

export default router;
